// unlikely sequence of characters for concatenating keys
export const separator = "_-_-";
